import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { MedicalFeeAmount } from "../../model/medical-fee/medical-fee-amount";
import {
  MedicalAppointmentAudintingSearchItem,
  MedicalAppointmentAudintingType,
} from "src/app/model/medical-appointment-auditing/medical-appointment-auditing-search-item";
import { MedicalAppointmentOrderAuditing } from "src/app/model/medical-appointment-auditing/medical-appointment-order-auditing";
import { MedicalAppointmentOrderAuditingUpdate, MedicalAppointmentPlanAuditingUpdate } from "src/app/model/medical-appointment-auditing/medical-appointment-order-auditing-update";

@Injectable({
  providedIn: "root",
})
export class MedicalAppointmentAuditingService {
  constructor(private dataService: DataService) {}

  private readonly getSearchItemsEndPoint: string =
    "/medicalAppointmentAuditing/getSearchItems/";

  private readonly getByDateAndPatientEndPoint: string =
    "/medicalAppointmentAuditing/getByDateAndPatient/";

  private readonly auditEndPoint: string = "/medicalAppointmentAuditing/audit/";

  private readonly updateOrderEndPoint: string =
    "/medicalAppointmentAuditing/updateOrder/";

  private readonly getOrderAuditingByOrderIdEndPoint: string =
    "/medicalAppointmentAuditing/GetOrderAuditingByOrderId/";

  async updateOrder(
    order: MedicalAppointmentOrderAuditingUpdate,
    plan: MedicalAppointmentPlanAuditingUpdate
  ): Promise<void> {
    return await this.dataService
      .post<void>(this.updateOrderEndPoint, {
        Plan: plan,
        Order: order
      } )
      .toPromise();
  }

  async getOrderAuditingByOrderId(
    orderId: number
  ): Promise<MedicalAppointmentOrderAuditing> {
    return await this.dataService
      .get<MedicalAppointmentOrderAuditing>(
        this.getOrderAuditingByOrderIdEndPoint,
        { orderId }
      )
      .toPromise();
  }

  async audit(
    typeId: number,
    appointmentId: number,
    validated: boolean,
    observation: string = ""
  ): Promise<void> {
    const params = {
      typeId: typeId,
      appointmentId: appointmentId,
      validated: validated,
      observation,
    };

    return await this.dataService
      .post<void>(this.auditEndPoint, params)
      .toPromise();
  }

  async getByDateAndPatient(
    date: Date,
    patientId: number
  ): Promise<MedicalAppointmentAudintingSearchItem[]> {
    const params = {
      date: date
        ? new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
          ).toDateString()
        : null,
      patientId: patientId,
    };

    return await this.dataService
      .get<MedicalAppointmentAudintingSearchItem[]>(
        this.getByDateAndPatientEndPoint,
        params
      )
      .toPromise();
  }

  async getSearchItems(
    over: boolean,
    cancel: boolean,
    atended: boolean,
    orderByPatient: boolean,
    isPatientDataValidated: boolean,
    isDocumentationValidated: boolean,
    isMedicalRecordValidated: boolean,
    isProcedureValidated: boolean,
    isReferredToCallCenter: boolean,
    orderByDate: boolean,
    whithFiles: boolean,
    from?: Date,
    to?: Date,
    patienteId?: number,
    equipmentId?: number,
    serviceId?: number,
    physicianId?: number,
    practiceRegionId?: number,
    assignmentFrom?: Date,
    assignmentTo?: Date,
    centerId?: number,
    entityId?: number
  ): Promise<MedicalAppointmentAudintingSearchItem[]> {
    const params = {
      over: over,
      cancel: cancel,
      atended: atended,
      isPatientDataValidated: isPatientDataValidated,
      isDocumentationValidated: isDocumentationValidated,
      isMedicalRecordValidated: isMedicalRecordValidated,
      isProcedureValidated: isProcedureValidated,
      isReferredToCallCenter: isReferredToCallCenter,
      from: from
        ? new Date(
            from.getFullYear(),
            from.getMonth(),
            from.getDate()
          ).toDateString()
        : null,
      to: to
        ? new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString()
        : null,
      patienteId: patienteId,
      equipmentId: equipmentId,
      serviceId: serviceId,
      physicianId: physicianId,
      practiceRegionId: practiceRegionId,
      assignmentFrom: assignmentFrom,
      assignmentTo: assignmentTo,
      centerId: centerId,
      entityId: entityId,
      orderByPatient,
      whithFiles,
      orderByDate,
    };

    return await this.dataService
      .get<MedicalAppointmentAudintingSearchItem[]>(
        this.getSearchItemsEndPoint,
        params
      )
      .toPromise();
  }
}
